import { Card, CardContent, Typography } from '@mui/material'
import type { SimulationInput } from '../../api/types'
import FieldsGrid from './FieldsGrid'
import { rentabiliteLocativeFields, type FieldKey } from './formFields'

export default function RentabiliteLocativeCard({
  form,
  setNum,
}: {
  form: SimulationInput
  setNum: (key: FieldKey, raw: string) => void
}) {
  return (
    <Card>
      <CardContent>
        <Typography variant="h6" sx={{ mb: 2 }}>
          Rentabilité locative
        </Typography>
        <FieldsGrid fields={rentabiliteLocativeFields} form={form} setNum={setNum} />
      </CardContent>
    </Card>
  )
}
